module.exports = __webpack_public_path__ + "img/mb.047a1234.jpg";